import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux';
import { inviteSimplePracticeClinician, inviteSimplePracticeClinicianBulk } from '../../redux/clinic/clinicSlice';

export default function useSimplePracticeInvites() {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const inviteOne = useCallback(async (clinicianId: string, email?: string) => {
    setLoading(true); setError(null); setSuccess(null);
    try {
      await dispatch(inviteSimplePracticeClinician({ clinicianId, email })).unwrap();
      setSuccess('Invite sent');
      return true;
    } catch (e: any) {
      setError(e?.message || 'Failed to send invite');
      return false;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  const inviteBulk = useCallback(async (clinicianIds: string[]) => {
    setLoading(true); setError(null); setSuccess(null);
    try {
      await dispatch(inviteSimplePracticeClinicianBulk({ clinicianIds })).unwrap();
      setSuccess('Bulk invites sent');
      return true;
    } catch (e: any) {
      setError(e?.message || 'Failed to send bulk invites');
      return false;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  return { inviteOne, inviteBulk, loading, error, success };
}


